import {
  KEYCLOAK_LOGIN_USER,
  KEYCLOAK_LOGIN_USER_SUCCESS,
  KEYCLOAK_LOGOUT_USER,
  KEYCLOAK_LOGIN_USER_ERROR,
} from '../actions';

export const keycloakLoginUser = (user, history) => ({
  type: KEYCLOAK_LOGIN_USER,
  payload: { user, history }
});
export const keycloakLoginUserSuccess = (user) => ({
  type: KEYCLOAK_LOGIN_USER_SUCCESS,
  payload: { user }
});
export const keycloakLoginUserError = (message) => ({
  type: KEYCLOAK_LOGIN_USER_ERROR,
  payload: { message }
});
export const keycloakLogoutUser = (history) => ({
  type: KEYCLOAK_LOGOUT_USER,
  payload: { history }
});

// export const registerUser = (user, history) => ({
//   type: REGISTER_USER,
//   payload: { user, history }
// })
// export const registerUserSuccess = (user) => ({
//   type: REGISTER_USER_SUCCESS,
//   payload: user
// })
// export const registerUserError = (message) => ({
//   type: REGISTER_USER_ERROR,
//   payload: { message }
// })